import React from 'react'
import OfflineCreditCard from '../../myapp/services/offline-bbps/OfflineCreditCard'

function OfflineBBPSPage() {
  return (
    <OfflineCreditCard/>
  )
}

export default OfflineBBPSPage